import type { Component, ComponentType } from '../types/builder';

function sizeToLinkSizing(size: string | undefined): { fontSize: number; iconSize: number } {
  if (size === 'small') return { fontSize: 16, iconSize: 48 };
  if (size === 'large') return { fontSize: 20, iconSize: 72 };
  return { fontSize: 18, iconSize: 64 };
}

// 'ctaButton' was removed from ComponentType, but legacy pages may still
// have it persisted on the server. Migrate by treating the input as opaque
// and emitting a current 'link' component.
function ctaButtonToLink(component: { id: string; position: number; settings?: Record<string, unknown> }): Component {
  const s = (component.settings ?? {}) as Record<string, unknown>;
  const { fontSize, iconSize } = sizeToLinkSizing(s.size as string | undefined);
  const main = s.text != null && String(s.text).trim() !== '' ? String(s.text) : 'Click here';
  const sub = s.subtext != null && String(s.subtext).trim() !== '' ? String(s.subtext) : '';
  const text = sub ? `${main}\n${sub}` : main;

  return {
    id: component.id,
    position: component.position,
    type: 'link' as ComponentType,
    settings: {
      text,
      url: s.link != null && String(s.link) !== '' ? String(s.link) : '#',
      openInNewTab: !!s.openInNewTab,
      icon: s.icon as string | undefined,
      backgroundImage: '',
      backgroundColor: (s.backgroundColor as string) ?? 'transparent',
      textColor: (s.textColor as string) ?? '#ffffff',
      hoverBackgroundColor:
        (s.hoverBackgroundColor as string) ?? (s.backgroundColor as string) ?? '#3b82f6',
      iconSize,
      fontSize,
      padding: typeof s.padding === 'number' ? s.padding : 16,
      animation:
        s.animation && s.animation !== 'none' && s.animation !== undefined
          ? s.animation
          : 'none',
    },
  } as Component;
}

/**
 * Upgrades legacy component blocks so the Builder and API use current types.
 * Safe to call on every load/save (idempotent for already-migrated pages).
 */
export function normalizeLandingPageComponents(components: unknown): Component[] {
  if (!Array.isArray(components)) return [];
  return components.map((c) => {
    if (!c || typeof c !== 'object') return c as Component;
    const comp = c as { type?: string; id: string; position: number; settings?: Record<string, unknown> };
    if (comp.type === 'ctaButton') return ctaButtonToLink(comp);
    return comp as Component;
  });
}
